import { Music } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ANTHEM_MP4 =
  "https://customer-assets-4nw71qhi.emergentagent.net/wingman/27422a56-9ef6-4b54-bcf6-0131f0c1fa3c/attachments/a9c4352bdf95459287a05d8a69381a46_mhg-anthem-montage-final.mp4";
const ANTHEM_AUDIO = "https://suno.com/s/8ExeaEiCUy8P5DyS";

export const AnthemVideo = ({
  testidPrefix,
  eyebrow,
  headline = "This is MyHeartGives",
  subtext = "Heart. Story. Community.",
  bg = "bg-ivory",
}) => (
  <section className={bg} data-testid={`${testidPrefix}-section`}>
    <div className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 lg:py-20">
      <Reveal>
        {eyebrow && <Eyebrow className="text-center">{eyebrow}</Eyebrow>}
        <h2
          className="mt-4 font-serif text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl"
          data-testid={`${testidPrefix}-headline`}
        >
          {headline}
        </h2>
        <p className="mt-3 font-serif text-lg italic text-cocoa" data-testid={`${testidPrefix}-subtext`}>
          {subtext}
        </p>
        <div
          className="mt-8 overflow-hidden rounded-2xl shadow-2xl"
          data-testid={`${testidPrefix}-player`}
        >
          <video
            controls
            muted
            playsInline
            preload="metadata"
            className="w-full"
            data-testid={`${testidPrefix}-video`}
          >
            <source src={ANTHEM_MP4} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <a
          href={ANTHEM_AUDIO}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-crimson transition-colors hover:text-crimson-deep"
          data-testid={`${testidPrefix}-audio-link`}
        >
          <Music className="h-4 w-4" />
          Prefer audio only? Listen to the anthem on Suno
        </a>
      </Reveal>
    </div>
  </section>
);
